import { mapGetters } from 'vuex'
import effects from '@/cloudia.library/utils/effects'
import HttpClient from '@/cloudia.library/httpClient'
import ClientDB from '@/cloudia.library/clientDB'
import conf from '@/cloudia.library/conf'

export default {
  data: () => ({
    HttpClient: new HttpClient(),
    Effects: effects,
    yearMonthList: [],
    yearList: [],
    monthList: []
  }),
  computed: {
    ...mapGetters({
      organizeList: 'masters/organizeList',
      subjectList: 'masters/subjectList',
      userList: 'masters/userList',
      userInfo: 'loginInfo/userInfo',
      isAdmin: 'loginInfo/isAdmin',
      authToken: 'loginInfo/authToken',
      fiscalYear: 'loginInfo/fiscalYear',
      selectedFiscalYear: 'loginInfo/selectedFiscalYear',
      isSelectedFiscalYear: 'loginInfo/isSelectedFiscalYear',
      isEditableFiscalYear: 'loginInfo/isEditableFiscalYear',
      isClosedFiscalYear: 'loginInfo/isClosedFiscalYear',
    })
  },
  methods: {
    loadMasters: function (masters) {
      const arry = masters || []
      return new Promise(resolve => {
        const promises = arry.map(m => {
          return new Promise(resolve => {
            this.HttpClient.get(`/api/v1/${m.controller}/GetAll`, this.authToken).then(data => {
              const target = m.propName
              this.$store.dispatch('masters/loadMasters', { data, target }).then(() => {
                resolve()
              })
            })
          })
        })
        Promise.all(promises).then(() => {
          resolve()
        })
      })
    },
    showInvalidMessage: function (message, invalidList) {
      console.log('viewMixins.showInvalidMessage', message, invalidList)
      const msg = message || ''
      const list = invalidList || []
      var keys = Object.keys(list)

      this.$bvToast.toast(msg, {
        title: 'メッセージ',
        autoHideDelay: 5000,
        variant: 'danger'
      })

      keys.forEach(k => {
        if (list[k] === undefined) { return }
        this.$refs[k].state = false
        const feedback = document.querySelector(`#${k}.invalid-feedback`)
        feedback.innerText = list[k]
      })
    },
    showSuccessMessage: function (message) {
      console.log('showSuccessMessage', message)
      this.$bvToast.toast(message, {
        title: 'メッセージ',
        autoHideDelay: 5000,
        variant: 'success'
      })
    },
    clearInvalidMessage: function () {
      var keys = Object.keys(this.$refs)
      keys.forEach(k => {
        this.$refs[k].state = null
        const feedback = document.querySelector(`#${k}.invalid-feedback`)
        feedback.innerText = ''
      })
    },
    loadYearMonthList: function () {
      return new Promise(resolve => {
        this.HttpClient.get(`/api/v1/date/YearMonthList?y=${this.fiscalYear}`, this.authToken).then(data => {
          this.yearMonthList = data.payload
          resolve()
        })
      })
    },
    loadYearList: function () {
      return new Promise(resolve => {
        this.HttpClient.get(`/api/v1/FiscalYear/GetAll`, this.authToken).then(data => {
          this.yearList = data.payload
          resolve()
        })
      })
    },
    loadMonthList: function () {
      return new Promise(resolve => {
        this.HttpClient.get(`/api/v1/date/MonthList?y=${this.fiscalYear}`, this.authToken).then(data => {
          this.monthList = data.payload
          resolve()
        })
      })
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    saveInputCache: function (propName, obj) {
      return new Promise(resolve => {
        const db = new ClientDB(conf.cacheStoreName)
        db.get(0).then((data) => {
          console.log('saveInputCache', data)
          const d = data || {}
          const v = d.value || {}

          v[propName] = obj
          db.register(0, v).then(() => {
            resolve()
          })
        })
      })
    },
    removeInputCache: function (propName) {
      return this.saveInputCache(propName, null)
    },
    findInputCache: function (propName) {
      return new Promise(resolve => {
        const db = new ClientDB(conf.cacheStoreName)
        db.get(0).then((data) => {
          if (data === null || data === undefined) {
            resolve(null)
            return
          }
          if (data.value === null || data.value === undefined) {
            resolve(null)
            return
          }
          const res = data.value[propName]
          resolve(res)
        })
      })
    },
    clearInputCache: function () {
      return new Promise(resolve => {
        const db = new ClientDB(conf.cacheStoreName)
        db.get(0).then((data) => {
          if (data === null || data === undefined) {
            resolve()
            return
          }
          db.register(0, null).then(() => {
            resolve()
          })          
        })
      })
    }
  }
}